import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authSlice from './authSlice';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Combine all reducers
const reducer = combineReducers({
  auth: authSlice.reducer,
  // Add other reducers here if needed
  // images: imageReducer,
  // fileimages: fileImageReducer,
  // ...
});

// Persist configuration
const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  blacklist: [], // Add slice names you don't want to persist
};

// Apply persistence to the combined reducer
const persistedReducer = persistReducer(persistConfig, reducer);

// Create the store with the persisted reducer
const store = configureStore({
  reducer: persistedReducer,
});

export default store;
